import type { RawTab } from '../../types';

import * as shared from './shared';

export const HomeTab: RawTab = {
  id: shared.id,

  link: shared.link,

  iconSource: require('./icons/fhs-home-inactive.png'),
  iconActiveSource: require('./icons/fhs-home-active.png'),

  text: shared.text,
};
